// Layout meta for routes
const hideLayoutMeta = { HideLayoutMeta: true }; // Switches layouts in App.vue

export { hideLayoutMeta };
